import styles from './CustomSliderMarker.module.scss'
import classNames from 'classnames'
import { CustomSliderMarkerProps } from './types.ts'

const CustomSliderMarker = ({
  children,
  style,
  className,
  valueToSet,
  handleInstalmentChange,
  setHoveringOnMark,
  hoveringOnMark
}: CustomSliderMarkerProps) => {
  return (
    <button
      {...{ style }}
      data-custom-slider-marker
      className={classNames(className, styles['mark-proposed-instalment'], {
        [styles.hover]: hoveringOnMark
      })}
      onMouseDown={(e) => {
        e.preventDefault()
        handleInstalmentChange(Number(valueToSet))
      }}
      onMouseEnter={() => setHoveringOnMark(true)}
      onMouseLeave={() => setHoveringOnMark(false)}
    >
      {children}
    </button>
  )
}

export default CustomSliderMarker
